import React from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import daLocale from 'dayjs/locale/da'
import upperFirst from 'lodash/upperFirst'

import Input from '../Input'
import calendarIcon from '../graphics/calendar.svg'
import { DEFAULT_FORMAT, formatDate, parseDate } from '../helpers/dates'
import './style.css'

export default function InputDatePicker({
  readOnly = false,
  value,
  onChange,
  errorMessage,
  name,
  onBlur,
  onKeyPress,
  id,
  fromMonth,
  toMonth,
  initialMonth,
  disabledDays,
  inputProps = {},
}) {
  if (readOnly) {
    return (
      <Input
        readOnly={true}
        value={formatDate(value, 'DD.MM.YYYY', null) || ''}
        placeholder="dd.mm.åååå"
        prefixIcon={calendarIcon}
      />
    )
  }
  return (
    <DayPickerInput
      onDayChange={onChange}
      classNames={{
        container: 'w-100',
        overlay: 'absolute z-1 shadow-4 bg-white ba b--light-gray',
      }}
      formatDate={formatDate}
      format={DEFAULT_FORMAT}
      parseDate={parseDate}
      component={Input}
      inputProps={{
        prefixIcon: calendarIcon,
        errorMessage: errorMessage,
        name: name,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        id: id,
        ...(inputProps || {}),
      }}
      value={value || ''}
      placeholder="dd.mm.åååå"
      dayPickerProps={{
        fromMonth,
        toMonth,
        initialMonth,
        disabledDays,
        firstDayOfWeek: 1,
        locale: 'da',
        months: daLocale.months.map(upperFirst),
        weekdaysLong: daLocale.weekdays.map(upperFirst),
        weekdaysShort: daLocale.weekdays
          .map((s) => s.substring(0, 2))
          .map(upperFirst),
      }}
    />
  )
}
